import React, { useEffect, useRef } from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import "./startearningpageStyle.css";

/* NEW: react-icons */
import {
  FaBolt,
  // FaBroom,
  FaFire,
  // FaGraduationCap,
  FaFaucet,
} from "react-icons/fa";
import { TbAirConditioning, TbCurrencyTaka } from "react-icons/tb";
import { useTranslation } from "react-i18next";
import SEO from "../../Components/SEO/SEO";
// import { MdWaterDrop } from "react-icons/md";

const StartEarningPage = () => {
  const registrationRef = useRef(null);
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const goToServitorSignup = () => navigate("/signup/servitor"); // absolute path

  //   const scrollToRegistration = () => {
  //     if (registrationRef.current) {
  //       registrationRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
  //     }
  //   };

  useEffect(() => {
    // Reveal animation for service cards on scroll
    const cards = document.querySelectorAll(".startearningpage-service-card");
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting)
            e.target.classList.add("startearningpage-inview");
        });
      },
      { threshold: 0.15 }
    );
    cards.forEach((c) => obs.observe(c));
    return () => obs.disconnect();
  }, []);

  return (
    <>
    <SEO
      title={
        i18n.language === "bn"
          ? "সেবা প্রদান করে আয় করুন | HelpNao"
          : "Earn Money as a Service Provider | HelpNao"
      }
      description={
        i18n.language === "bn"
          ? "HelpNao-তে দক্ষ সেবা প্রদানকারী হিসেবে যোগ দিন। যাচাইকরণ সম্পন্ন করে কাজ নিন এবং সততা ও দক্ষতার মাধ্যমে আয় করুন।"
          : "Join HelpNao as a skilled service provider. Get verified, accept jobs, and earn money with honesty, punctuality, and expertise."
      }
      path="/earnwithHelpNao"
      lang={i18n.language === "bn" ? "bn" : "en"}
      jsonLd={{
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name":
          i18n.language === "bn"
            ? "HelpNao-তে আয় করুন"
            : "Start Earning with HelpNao",
        "url": "https://helpnao.com/earnwithHelpNao",
        "inLanguage": i18n.language === "bn" ? "bn-BD" : "en"
      }}
    />

      <Navbar />

      {/* HERO */}
      <section className="startearningpage-hero">
        {/* Floating background circles */}
        <div className="startearningpage-float startearningpage-float-1" />
        <div className="startearningpage-float startearningpage-float-2" />
        <div className="startearningpage-float startearningpage-float-3" />

        <div className="startearningpage-container">
          <div className="startearningpage-hero-grid">
            {/* Left */}
            <div className="startearningpage-hero-left">
              <h1 className="startearningpage-hero-title">
                <span className="startearningpage-underline">
                  সেবা প্রদান করে আয় করুন
                </span>
              </h1>
              <p className="startearningpage-hero-sub">
                আপনার দক্ষতা ও অভিজ্ঞতা দিয়ে মাসিক{" "}
                <strong>৩০,০০০ - ৫০,০০০+ টাকা</strong> পর্যন্ত আয় করুন
              </p>

              {/* KPIs */}
              {/* <div className="startearningpage-kpi-grid">
                <div className="startearningpage-kpi-card">
                  <div className="startearningpage-kpi-value">৫০,০০০+</div>
                  <div className="startearningpage-kpi-label">সক্রিয় সেবা প্রদানকারী</div>
                </div>
                <div className="startearningpage-kpi-card">
                  <div className="startearningpage-kpi-value">১০ লক্ষ+</div>
                  <div className="startearningpage-kpi-label">সেবা সম্পন্ন</div>
                </div>
                <div className="startearningpage-kpi-card">
                  <div className="startearningpage-kpi-value">৪.৮★</div>
                  <div className="startearningpage-kpi-label">গড় রেটিং</div>
                </div>
              </div> */}

              <button
                className="startearningpage-cta"
                onClick={goToServitorSignup}
              >
                এখনই যোগদান করুন →
              </button>
            </div>

            {/* Right */}
            <div className="startearningpage-hero-right">
              <div className="startearningpage-hero-bubble">
                <div className="startearningpage-pulse-ring" />
                <div className="startearningpage-hero-bubble-inner">
                  {/* NEW: BDT (Taka) icon */}
                  <TbCurrencyTaka
                    className="startearningpage-hero-icon"
                    aria-label="Taka Icon"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="startearningpage-services">
        <div className="startearningpage-container">
          <div className="startearningpage-section-head">
            <h2>আপনার দক্ষতা অনুযায়ী সেবা প্রদান করুন</h2>
            <p>HelpNao-তে যে সব সেবা দিয়ে আয় করতে পারবেন</p>
          </div>

          <div className="startearningpage-services-grid">
            {/* Electrician */}
            <div className="startearningpage-service-card">
              <div className="startearningpage-service-icon">
                <FaBolt className="se-icon" aria-label="Electrician" />
              </div>
              <h3>ইলেকট্রিশিয়ান</h3>
              <p>বৈদ্যুতিক সমস্যা সমাধান</p>
            </div>

            {/* Home Cleaning */}
            {/* <div className="startearningpage-service-card">
              <div className="startearningpage-service-icon">
                <FaBroom className="se-icon" aria-label="Home Cleaning" />
              </div>
              <h3>হোম ক্লিনিং</h3>
              <p>ঘর পরিষ্কার</p>
            </div> */}

            {/* Plumber */}
            <div className="startearningpage-service-card">
              <div className="startearningpage-service-icon">
                <FaFaucet className="se-icon" aria-label="Plumber" />
              </div>
              <h3>প্লাম্বার</h3>
              <p>স্যানিটারি ও পানি-গ্যাস লাইনের সমস্যা সমাধান</p>
            </div>

            {/* AC Service */}
            <div className="startearningpage-service-card">
              <div className="startearningpage-service-icon">
                <TbAirConditioning
                  className="se-icon"
                  aria-label="AC Service"
                />
              </div>
              <h3>এসি সার্ভিস</h3>
              <p>এয়ার কন্ডিশনার মেরামত</p>
            </div>

            {/* Gas Chula */}
            <div className="startearningpage-service-card">
              <div className="startearningpage-service-icon">
                <FaFire className="se-icon" aria-label="Gas Stove Service" />
              </div>
              <h3>গ্যাস চুলা</h3>
              <p>গ্যাস চুলা মেরামত</p>
            </div>

            {/* Filter Service (Water Filter) */}
            {/* <div className="startearningpage-service-card">
              <div className="startearningpage-service-icon">
                <MdWaterDrop
                  className="se-icon"
                  aria-label="Water Filter Service"
                />
              </div>
              <h3>ফিল্টার সার্ভিস</h3>
              <p>পানি ফিল্টার পরিষ্কার ও মেরামত</p>
            </div> */}

            {/* Tutor Service */}
            {/* <div className="startearningpage-service-card">
              <div className="startearningpage-service-icon">
                <FaGraduationCap
                  className="se-icon"
                  aria-label="Tutor Service"
                />
              </div>
              <h3>টিউটর সার্ভিস</h3>
              <p>বাসায় ও অনলাইনে পড়ানো</p>
            </div> */}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="startearningpage-how">
        <div className="startearningpage-container">
          <div className="startearningpage-section-head">
            <h2>কীভাবে কাজ করে?</h2>
            <p>মাত্র ৪টি সহজ ধাপে আয় শুরু করুন</p>
          </div>

          <div className="startearningpage-steps-grid">
            <div className="startearningpage-step">
              <div className="startearningpage-step-badge">১</div>
              <h3>নিবন্ধন করুন</h3>
              <p>আপনার তথ্য ও দক্ষতার বিবরণ দিয়ে নিবন্ধন করুন</p>
            </div>

            <div className="startearningpage-step">
              <div className="startearningpage-step-badge">২</div>
              <h3>যাচাইকরণ</h3>
              <p>আমাদের টিম আপনার প্রোফাইল ও কাগজপত্র যাচাই করবে</p>
            </div>

            <div className="startearningpage-step">
              <div className="startearningpage-step-badge">৩</div>
              <h3>কাজ পান</h3>
              <p>অ্যাকাউন্ট অনুমোদনের পর গ্রাহকদের কাজের অনুরোধ পান</p>
            </div>

            <div className="startearningpage-step">
              <div className="startearningpage-step-badge">৪</div>
              <h3>অর্থ পান</h3>
              <p>সেবা শেষে কাস্টমারের কাছ থেকে সরাসরি পেমেন্ট নিন</p>
            </div>
          </div>
        </div>
      </section>

      {/* REQUIREMENTS + PERKS */}
      <section
        className="startearningpage-reqs"
        ref={registrationRef}
        id="startearningpage-registration"
      >
        <div className="startearningpage-container">
          <div className="startearningpage-section-head">
            <h2>আবেদন করার জন্য যা প্রয়োজন</h2>
            <p>
              আপনি কি সেবা প্রদানকারী হতে ইচ্ছুক? জেনে নিন সেবা প্রদানকারী হতে
              কি কি প্রয়োজন
            </p>
          </div>

          <div className="startearningpage-reqs-grid">
            {/* General requirements */}
            <div className="startearningpage-req-col">
              <div className="startearningpage-req-title">
                <div className="startearningpage-req-title-badge">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h3>সাধারণ প্রয়োজনীয়তা</h3>
              </div>

              {/* <div className="startearningpage-req-item">
                <div className="startearningpage-req-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V4a2 2 0 114 0v2m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
                    />
                  </svg>
                </div>
                <div>
                  <h4>জাতীয় পরিচয়পত্রের মূল কপি</h4>
                  <p>বৈধ এনআইডি কার্ড বা পাসপোর্টের নম্বর প্রয়োজন</p>
                </div>
              </div>

              <div className="startearningpage-req-item">
                <div className="startearningpage-req-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                </div>
                <div>
                  <h4>সাম্প্রতিক ছবি</h4>
                  <p>মুখ স্পষ্ট দেখা যায় এমন সাম্প্রতিক ছবি</p>
                </div>
              </div>

              <div className="startearningpage-req-item">
                <div className="startearningpage-req-icon">
                  <svg
                    className="servitorsignupotp-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <rect
                      x="7"
                      y="3"
                      width="10"
                      height="18"
                      rx="2"
                      ry="2"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <circle
                      cx="12"
                      cy="18"
                      r="1"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div>
                  <h4>সক্রিয় মোবাইল নম্বর</h4>
                  <p>যাতে দ্রুত যোগাযোগ করা যায়</p>
                </div>
              </div> */}

              {/* ✅ NEW: 2-column grid wrapper */}
                <div className="startearningpage-req-items-grid">
                  {/* ✅ NEW FIRST ITEM: Smart phone */}
                  <div className="startearningpage-req-item">
                    <div className="startearningpage-req-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <rect
                          x="7"
                          y="3"
                          width="10"
                          height="18"
                          rx="2"
                          ry="2"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <circle
                          cx="12"
                          cy="18"
                          r="1"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div>
                      <h4>স্মার্টফোন</h4>
                      <p>অ্যাপ ব্যবহার ও অর্ডার গ্রহণের জন্য স্মার্টফোন থাকা আবশ্যক</p>
                    </div>
                  </div>

                  <div className="startearningpage-req-item">
                    <div className="startearningpage-req-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V4a2 2 0 114 0v2m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
                        />
                      </svg>
                    </div>
                    <div>
                      <h4>জাতীয় পরিচয়পত্রের মূল কপি</h4>
                      <p>বৈধ এনআইডি কার্ড বা পাসপোর্টের নম্বর প্রয়োজন</p>
                    </div>
                  </div>

                  <div className="startearningpage-req-item">
                    <div className="startearningpage-req-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                    </div>
                    <div>
                      <h4>সাম্প্রতিক ছবি</h4>
                      <p>মুখ স্পষ্ট দেখা যায় এমন সাম্প্রতিক ছবি</p>
                    </div>
                  </div>

                  <div className="startearningpage-req-item">
                    <div className="startearningpage-req-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <rect
                          x="7"
                          y="3"
                          width="10"
                          height="18"
                          rx="2"
                          ry="2"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <circle
                          cx="12"
                          cy="18"
                          r="1"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div>
                      <h4>সক্রিয় মোবাইল নম্বর</h4>
                      <p>যাতে দ্রুত যোগাযোগ করা যায়</p>
                    </div>
                  </div>
                </div>
            </div>

            {/* Tutor requirements */}
            {/* <div className="startearningpage-req-col">
              <div className="startearningpage-req-title">
                <div className="startearningpage-req-title-badge">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                    />
                  </svg>
                </div>
                <h3>টিউটর সার্ভিসের জন্য অতিরিক্ত</h3>
              </div>

              <div className="startearningpage-req-item">
                <div className="startearningpage-req-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                </div>
                <div>
                  <h4>সম্পূর্ণ তথ্য পূরণ</h4>
                  <p>শিক্ষাগত যোগ্যতা, অভিজ্ঞতা সহ সকল তথ্য পূরণ করুন</p>
                </div>
              </div>

              <div className="startearningpage-req-item">
                <div className="startearningpage-req-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                    />
                  </svg>
                </div>
                <div>
                  <h4>ছাত্র আইডি কার্ড</h4>
                  <p>বর্তমান বা সর্বশেষ শিক্ষাপ্রতিষ্ঠানের আইডি কার্ড</p>
                </div>
              </div>

              <div className="startearningpage-req-item">
                <div className="startearningpage-req-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                </div>
                <div>
                  <h4>রিজিউমি/সিভি</h4>
                  <p>শিক্ষাগত যোগ্যতা ও অভিজ্ঞতার বিস্তারিত রিজিউমি</p>
                </div>
              </div>
            </div> */}
            
          </div>

          {/* Perks / Bonus & Fees */}
          <div className="startearningpage-perks">
            <div className="startearningpage-perk">
              <div className="startearningpage-perk-badge">৳১০০ বোনাস</div>
              <p>
                নিবন্ধন ও সম্পূর্ণ যাচাইকরণ শেষে আপনার অ্যাকাউন্টে প্রাথমিক
                বোনাস যুক্ত হবে
              </p>
            </div>
            <div className="startearningpage-perk">
              {/* <div className="startearningpage-perk-badge">মাত্র ৫% কমিশন</div> */}
              <div className="startearningpage-perk-badge">সর্বনিম্ন কমিশন</div>
              <p>সেবা সম্পন্নের পর সর্বনিম্ন কমিশনে আয় বজায় রাখুন</p>
            </div>
            <div className="startearningpage-perk">
              <div className="startearningpage-perk-badge">
                ব্যালান্স রিচার্জ
              </div>
              <p>যখন খুশি নিজের ব্যালান্স রিচার্জ করতে পারবেন</p>
            </div>
          </div>

          {/* Verification Process */}
          <div className="startearningpage-verify">
            <h3>যাচাইকরণ প্রক্রিয়া</h3>
            <div className="startearningpage-verify-grid">
              <div className="startearningpage-verify-card">
                <div className="startearningpage-verify-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                </div>
                <h4>নিবন্ধনের পর</h4>
                <p>
                  আমরা আপনার সাথে হোয়াটসঅ্যাপে যোগাযোগ করে জাতীয় পরিচয়পত্রের
                  মূল কপির ছবি চাইব
                </p>
              </div>
              <div className="startearningpage-verify-card">
                <div className="startearningpage-verify-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                    />
                  </svg>
                </div>
                <h4>কাগজপত্র যাচাই</h4>
                <p>
                  আমাদের টিম সকল কাগজপত্র যাচাই করে আপনার যোগ্যতা নিশ্চিত করবে
                </p>
              </div>
              <div className="startearningpage-verify-card">
                <div className="startearningpage-verify-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h4>অ্যাকাউন্ট অনুমোদন</h4>
                <p>
                  যাচাই সম্পন্ন হলে আপনার অ্যাকাউন্ট চালু হবে এবং অর্ডার পেতে
                  শুরু করবেন
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="startearningpage-cta-strip">
        <div className="startearningpage-container startearningpage-cta-inner">
          <h2>আজই শুরু করুন আয়ের নতুন পথ</h2>
          {/* <p>হাজার হাজার মানুষ ইতিমধ্যে HelpNao দিয়ে সফলভাবে আয় করছেন</p> */}
          <p>মানুষ ইতিমধ্যে HelpNao দিয়ে সফলভাবে আয় করছেন</p>
          <button
            className="startearningpage-cta big"
            onClick={goToServitorSignup}
          >
            সেবা প্রদানকারী হিসেবে যোগ দিন
          </button>
          <div className="startearningpage-cta-note">
            ✓ বিনামূল্যে নিবন্ধন ✓ তাৎক্ষণিক অনুমোদন
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default StartEarningPage;
